import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackDealTypeClick } from './tracking';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setFavoriteEntityType } from '../../actions/filters';
import { EntityTypeToggle } from '../../components/EntityTypeToggle';
import { EEntityType } from '../../types/filters';
import { IApplicationState } from '../../types/redux';

export const EntityTypeToggleContainer = () => {
  const favoriteEntityType = useSelector((state: IApplicationState) => state.filters.favoriteEntityType);

  const dispatch = useDispatch();

  const setEntityType = (entityType: EEntityType | null) => {
    trackDealTypeClick(entityType);
    dispatch(setFavoriteEntityType(entityType));
    dispatch(fetchFavoriteEntities());
  };

  return <EntityTypeToggle favoriteEntityType={favoriteEntityType} setEntityType={setEntityType} />;
};
